<script context="module" lang="ts">
  preloadIcon("check-circle-outline");
</script>

<script lang="ts">
  import Button from "@brave/leo/src/components/button/button.svelte";
  import Icon, { preloadIcon } from "@brave/leo/src/components/icon/icon.svelte";
  import { m } from "$lib/paraglide/messages";
  import type { ComponentProps } from "svelte";

  type $$Props = ComponentProps<Button<any, any, any>> & {
    textToCopy: string;
  };

  export let textToCopy = "";

  let copied = false;
  const handleClick = async () => {
    await navigator.clipboard.writeText(textToCopy);
    copied = true;
    setTimeout(() => (copied = false), 1500);
  };
</script>

<Button {...$$restProps} onClick={handleClick}>
  {#if !$$restProps.fab}
    {#if !copied}
      <slot>{m.copy_button_default()}</slot>
    {:else}
      {m.copied_success_message()}
    {/if}
  {/if}
  <Icon slot="icon-after" name={copied ? "check-circle-outline" : "copy"} />
</Button>
